import moment from 'moment';



 


        class Storefront{
         constructor(params,o){
          this.id = o.id;
          this.filter = (o.filter) ? o.filter : false;
          this.accountType = "Storefront";
            this._types = {
               
                
            }
            this.generic = {
              name:"",
              id:"",
              platformId:"",
              customerId:"",
              loginCustomerId:false,
              description:"",
              subTitle:"",
              accountType:"Storefront"
            }
               
               
            this.setParameters(o);
               

            for (var t of  Object.keys(this._types)){
             if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                 if (pt.objectIds.indexOf(this.id) > -1){
                   for (var oid of pt.pivotObjectIds){
                     if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                        params.accounts[pt.pivotAccountId][oid].filter = this.filter;
                       params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                     var model = new this._types[t](params,params.accounts[pt.pivotAccountId][oid]);
                     this.setModelParameters(model);
                     }
                   }
                 }
             }
           }
           }
         
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }

         
             
           setId(id){
               this.id = id;
               this.generic.id = id;
         }


       setTitle(str){
         this.generic.title = (this.generic.name == "") ? str : str + " " + this.generic.name;
       }
       setStorefrontAddress(add){
        this.generic.description = add;
        this.generic.subTitle = add;
       }
      setStoreCode(str){
       this.generic.name = str;
       
     }
     setStoreInformation(obj){
      this.storeInformation = JSON.parse(obj);
    }

     setPhoneNumbers(str){
      this.generic.label = str;
     }

       setPlatformId(str){
         this.generic.platformId = str;
         this.platformId = str;
       }

        
    
           
       

       setTruncate(obj){
        if (obj){
          var tr = {};
          Object.keys(obj).map((o) => {
              var nk = (o == 21) ? "Storefront" : o;
              tr[nk] = obj[o];
          })
        this.truncate = tr;
        this.filtered = (tr && tr[this.accountType] && (tr[this.accountType].indexOf(this.id) > -1)) ? false : true;
        }
      }
         
         

      setOriginAccountId(id){
        this.originAccountId = id;
        this.generic.originAccountId = id;
      }
      setOriginId(id){
        this.originId = id;
        this.generic.originId = id;
      }
       
       setModelParameters(params){
           this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
           this[params.accountType].push(params);
       }
     }
export default Storefront;
        